import React, { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import "chart.js/auto";
import { getSalesByTime } from "../../api/commercial/commercialApi";

const TimeSlotSalesBarChart = ({ district }) => {
  const [chartData, setChartData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getSalesByTime(district);
        const data = await response;

        const maxSalesAmount = Math.max(
          ...data.map((item) => item.salesAmount)
        );
        const labels = data.map((item) => item.timeSlot);
        const salesAmounts = data.map((item) => item.salesAmount);

        const backgroundColors = salesAmounts.map((amount) =>
          amount === maxSalesAmount ? "#D9601A" : "#FFA07A"
        );

        setChartData({
          labels: labels,
          datasets: [
            {
              label: "시간대별 매출",
              data: salesAmounts,
              backgroundColor: backgroundColors,
              borderColor: "#D9601A",
              borderWidth: 1,
            },
          ],
        });
      } catch (error) {
        console.error("Error fetching time slot sales data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [district]);

  if (isLoading) return <p>Loading...</p>;
  if (!chartData) return <p>No data available</p>;

  return (
    <Bar
      data={chartData}
      options={{
        indexAxis: "y", // 가로 막대 설정
        responsive: true,
        maintainAspectRatio: false, // 부모 크기에 맞추기
        plugins: {
          legend: {
            display: false, // 범례 비활성화
          },
          tooltip: {
            callbacks: {
              label: function (context) {
                const value = context.raw || 0;
                return `${context.label}: ${value.toLocaleString()}원`;
              },
            },
            backgroundColor: "#333333",
            titleFont: {
              size: 16,
              family: "Arial, sans-serif",
              weight: "bold",
            },
            bodyFont: {
              size: 14,
              family: "Arial, sans-serif",
            },
            borderWidth: 1,
            borderColor: "#FFFFFF",
          },
        },
        scales: {
          x: {
            title: {
              display: true,
              text: "매출 금액 (원)",
              color: "#4A4A4A",
              font: {
                size: 14,
              },
            },
            ticks: {
              display: false,
            },
          },
          y: {
            title: {
              display: true,
              text: "시간대",
              color: "#4A4A4A",
              font: {
                size: 14,
              },
            },
            grid: {
              drawOnChartArea: false,
            },
          },
        },
      }}
    />
  );
};

export default TimeSlotSalesBarChart;
